import { useEffect } from "react"
import { useShallow } from "zustand/react/shallow"
import { useStateWithCallbackLazy } from "use-state-with-callback"

// components
import RJCrossReferenceTable from "./RJCrossReferenceTable"
import TableVersionComparisonWrapper from "../../components/TableVersionComparisonWrapper/TableVersionComparisonWrapper"

// context
import useProtocolTableArmsStore from "../../../hooks/stores/useProtocolTableArmsStore"
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"
import useAuthoringVersionStore from "../../../hooks/stores/useAuthoringVersionStore"

const CrossReferenceWrapper = (props) => {
  const { id, onChange, formContext } = props

  const { formDataRef } = formContext

  const { readOnly, formStatus, showVersionCompare, customTableWidthClassName } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      formStatus: state.formStatus,
      showVersionCompare: state.showVersionCompare,
      customTableWidthClassName: state.customTableWidthClassName,
    }))
  )

  const { versionData, selectedVersion } = useAuthoringVersionStore(
    useShallow((state) => ({
      versionData: state.versionData,
      selectedVersion: state.selectedVersion,
    }))
  )

  const { arms, interventions } = useProtocolTableArmsStore()

  const [tableData, setTableData] = useStateWithCallbackLazy(null)
  const [tableMounting, setTableMounting] = useStateWithCallbackLazy(true)

  useEffect(() => {
    if (formStatus === "ready" && tableData && readOnly === false && tableMounting === false) {
      console.log("Cross Ref Change")
      onChange(tableData)
    }
  }, [tableData])

  useEffect(() => {
    const crossref = formDataRef?.protocol?.study_arms?.crossref

    if (crossref && crossref.arms && crossref?.interventions) {
      setTableData(crossref)
    } else {
      setTableData({
        arms: [],
        interventions: [],
      })
    }

    return () => {
      setTableMounting(true)
    }
  }, [])

  useEffect(() => {
    if (tableData !== null) setTableMounting(false)
  }, [tableMounting, tableData])

  if (tableMounting) return <></>

  return (
    <div className={`results-table form-table-print ${customTableWidthClassName}`}>
      <RJCrossReferenceTable
        {...props}
        arms={arms}
        studyType={formDataRef?.protocol?.study_type}
        interventions={interventions}
        tableData={tableData}
        setTableData={setTableData}
      />
      {versionData && selectedVersion && showVersionCompare && (
        <TableVersionComparisonWrapper>
          <RJCrossReferenceTable
            {...props}
            arms={versionData?.study_data.protocol?.study_arms?.arms || []}
            studyType={versionData?.study_data?.protocol?.study_type}
            interventions={versionData?.study_data.protocol?.study_arms?.interventions || []}
            tableData={versionData?.study_data?.protocol?.study_arms?.crossref}
            setTableData={() => {}}
          />
        </TableVersionComparisonWrapper>
      )}
    </div>
  )
}

export default CrossReferenceWrapper
